import withPayByPayto from 'features/to/HOCs/payment/withPayByPayto';
import withPaytoErrorCodeModal from 'features/to/HOCs/payment/withPaytoErrorCodeModal';
import usePortalModal from 'hooks/usePortalModal';
import React from 'react';
import { functionUtils } from 'utils';
import Popup from './popup';

const PaytoOTPVerificationPopup = withPayByPayto(
  withPaytoErrorCodeModal(Popup)
);

const PaytoOTPVerificationModal = ({
  isShow,
  action,
  actionOnClose,
  modalOptions,
  modalData,
}) => {
  const { closePortalModalName } = usePortalModal();

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionOnClose)) {
      actionOnClose();
    }
    closePortalModalName();
  };

  return (
    <PaytoOTPVerificationPopup
      isOpen={isShow}
      onClose={handleOnClose}
      onClick={action}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      modalOptions={modalOptions}
      modalData={modalData}
    />
  );
};

export default PaytoOTPVerificationModal;
